module.exports = __webpack_public_path__ + "img/SO-image.9875d921.jpg";